
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    question: "Miten OrderSales.AI:n tekoäly on räätälöity verkkokaupoille?",
    answer: "OrderSales.AI:n tekoäly on rakennettu kattavalla tietämyksellä verkkokauppojen tuotevalikoimista, hinnoittelustrategioista, takuutiedoista ja teknisistä spesifikaatioista. Se ymmärtää verkkokauppojen ainutlaatuiset haasteet ja tarjoaa juuri sinun liiketoimintaasi sopivia ratkaisuja."
  },
  {
    question: "Kuinka kauan OrderSales.AI:n tekoälyratkaisun käyttöönotto kestää?",
    answer: "Useimmat verkkokaupat voivat olla käyttövalmiita tekoälyratkaisullamme 1-2 viikossa. Tiimimme hoitaa asennuksen, koulutuksen ja integroinnin olemassa oleviin järjestelmiisi tehden prosessista sujuvan ja vaivattoman."
  },
  {
    question: "Voiko OrderSales.AI:n tekoäly integroitua olemassa oleviin kassakone- ja varastonhallintajärjestelmiimme?",
    answer: "Kyllä, OrderSales.AI:n tekoäly on suunniteltu integroitumaan saumattomasti kaikkien suurten verkkokauppojen käyttämien kassakone- ja varastonhallintajärjestelmien kanssa, mukaan lukien räätälöidyt kauppajärjestelmät."
  },
  {
    question: "Miten tekoäly pysyy ajan tasalla uusista tuotejulkaisuista?",
    answer: "Tiimimme ylläpitää läheisiä suhteita valmistajiin ja saa säännöllisiä tuotepäivityksiä ja koulutusmateriaaleja. Tekoäly päivitetään automaattisesti uusilla tuotetiedoilla, spesifikaatioilla ja myyntiargumenteilla heti kun ne ovat saatavilla."
  },
  {
    question: "Onko asiakasdata turvassa OrderSales.AI:n tekoälyn kanssa?",
    answer: "Ehdottomasti. Toteutamme yritystason turvatoimet, mukaan lukien salaus, turvallinen datan tallennus ja tiukat pääsynhallintakeinot. Olemme täysin tietosuoja-asetusten mukaisia emmekä koskaan jaa tietojasi kolmansille osapuolille."
  },
  {
    question: "Voimmeko räätälöidä tekoälyn vastaamaan verkkokauppamme brändäystä ja viestintätyyliä?",
    answer: "Kyllä, tekoäly voidaan täysin räätälöidä vastaamaan verkkokauppasi brändäystä, viestintätyyliä ja tiettyjä liiketoimintasääntöjä varmistaen yhdenmukaisen asiakaskokemuksen kaikissa kanavissa."
  },
  {
    question: "Millaista tukea OrderSales.AI tarjoaa?",
    answer: "Paketistasi riippuen sinulla on käytössäsi sähköpostituki, live-chat tai oma asiakkuuspäällikkö. Tarjoamme myös säännöllisiä koulutuksia, yksityiskohtaista dokumentaatiota ja tietopankkia auttaaksemme sinua saamaan kaiken irti tekoälyratkaisustasi."
  }
];

const FAQ = () => {
  return (
    <section id="faq" className="section bg-wallpaper-lightGray/30">
      <div className="container-custom">
        <div className="text-center max-w-3xl mx-auto mb-20">
          <h2 className="wallpaper-subtitle mb-6">
            Usein kysytyt <span className="font-wallpaper-serif italic">kysymykset</span>
          </h2>
          <p className="text-wallpaper-gray max-w-2xl mx-auto font-wallpaper">
            Löydä vastauksia yleisiin kysymyksiin OrderSales.AI:n tekoälyratkaisuista verkkokaupoille.
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, index) => (
              <AccordionItem key={index} value={`item-${index}`} className="border-b border-wallpaper-lightGray">
                <AccordionTrigger className="text-left font-light py-6 text-base hover:text-wallpaper-darkGray">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-wallpaper-gray text-sm pb-6 font-wallpaper">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>

        <div className="mt-16 text-center">
          <p className="text-wallpaper-gray mb-6 font-wallpaper">
            Etkö löytänyt kysymystäsi? <span className="font-wallpaper-serif italic">Ota yhteyttä tiimiimme.</span>
          </p>
          <div className="inline-flex items-center justify-center space-x-8 p-4 bg-white shadow-sm">
            <span className="text-xs font-light tracking-wider uppercase">
              info@ordersales.ai
            </span>
            <span className="w-px h-4 bg-wallpaper-lightGray"></span>
            <span className="text-xs font-light tracking-wider uppercase">
              +358 10 123 4567
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
